import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor(private ngxService: NgxUiLoaderService) {}

  // Method to start and stop loader around an Observable operation
  runWithLoader<T>(observable: Observable<T>): Observable<T> {
    this.ngxService.start(); // Start loader
    return observable.pipe(
      tap({
        next: () => {}, // Handle each emission if needed
        error: () => this.ngxService.stop(), // Stop loader in case of error
        complete: () => this.ngxService.stop(), // Stop loader when the operation completes
      })
    );
  }
  

  runWithLoaderSync(operation: () => void): void {
    this.ngxService.start();  // Start the loader
    try {
      operation();  // Run the synchronous operation
    } finally {
      this.ngxService.stop();  // Stop the loader after the operation is done
    }
  }
}
